module.exports = __webpack_public_path__ + "img/exchange-bg.f93379fb.svg";